module.exports = __webpack_public_path__ + "img/cn.87d6c351.svg";